const resolved = new Map();
const inFlight = new Map();

const delay = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds));

export const stableDataUrl = (url, version = "") => {
  const value = String(version || "").trim();
  if (!value) return url;
  return `${url}${String(url).includes("?") ? "&" : "?"}v=${encodeURIComponent(value)}`;
};

export async function fetchStaticJson(url, { fetchImpl = fetch, signal, retries = 1, retryDelayMs = 250 } = {}) {
  let lastError;
  for (let attempt = 0; attempt <= retries; attempt += 1) {
    try {
      const response = await fetchImpl(url, { credentials: "omit", cache: "default", signal });
      if (!response.ok) throw new Error(`not ok: ${response.status}`);
      return await response.json();
    } catch (error) {
      if (signal?.aborted || error?.name === "AbortError") throw error;
      lastError = error;
      if (attempt < retries) await delay(retryDelayMs * (attempt + 1));
    }
  }
  throw lastError;
}

export function loadStaticSportOnce(key, loader) {
  const normalizedKey = String(key || "").toUpperCase();
  if (resolved.has(normalizedKey)) return Promise.resolve(resolved.get(normalizedKey));
  if (inFlight.has(normalizedKey)) return inFlight.get(normalizedKey).promise;
  const controller = new AbortController();
  const promise = Promise.resolve().then(() => loader(controller.signal)).then((payload) => {
    resolved.set(normalizedKey, payload);
    return payload;
  }).finally(() => {
    if (inFlight.get(normalizedKey)?.promise === promise) inFlight.delete(normalizedKey);
  });
  inFlight.set(normalizedKey, { controller, promise });
  return promise;
}

export function abortStaticSportLoad(key) {
  inFlight.get(String(key || "").toUpperCase())?.controller.abort();
}

export function resetStaticSportsDataLoaderForTests() {
  inFlight.forEach(({ controller }) => controller.abort());
  inFlight.clear();
  resolved.clear();
}
